import React from "react";

import { useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";

import { FilterProps } from "./Filter.props";
import { Switch } from "@src/components/Switch/Switch";
import { Input } from "@src/components/Input/Input";
import { Button } from "@src/components/Button/Button";
import { ReactComponent as SearchIcon } from "@src/assets/icons/search.svg";
import { ReactComponent as FilterIcon } from "@src/assets/icons/filter.svg";
import { selectCurrentLanguage } from "@src/store/app_manager/selector";

import data from "@src/data/data.json";

export const Filter: React.FC<FilterProps> = (props) => {
  const { title, subTitle, onOpen, setSearch } = props;

  const [params] = useSearchParams();

  const language = useSelector(selectCurrentLanguage);

  const [value, setValue] = React.useState<string>(
    () => params.get("order_code") ?? ""
  );

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    setValue(e.target.value);
  };

  const onKeyUpInputSearch = (e: React.KeyboardEvent) => {
    if (e.key === "Enter") {
      setSearch && setSearch(value);
    }
  };

  return (
    <Box
      width="100%"
      display="flex"
      alignItems="center"
      justifyContent="space-between"
    >
      <Typography fontSize="32px" noWrap fontWeight="700">
        {title}
        <Typography display="inline-block" fontSize="20px" fontWeight="600">
          {subTitle}
        </Typography>
      </Typography>

      <Box display="flex" alignItems="center">
        <Box mx="10px">
          <Input
            value={value}
            onChange={handleChange}
            onKeyUp={onKeyUpInputSearch}
            inputSize="m"
            endAdornment={<SearchIcon />}
            placeholder={data[language].Orders.OrdersHeader.SearchPlaceholder}
          />
        </Box>
        <Button
          buttonSize="m"
          variant="contained"
          startIcon={<FilterIcon />}
          onClick={onOpen}
          sx={{
            backgroundColor: "#39d29f",
            "&:hover": { boxShadow: "none", backgroundColor: "#07714B" },
          }}
        >
          {data[language].Orders.OrdersHeader.FilterButtonModal.Title}
        </Button>
      </Box>
    </Box>
  );
};
